import type { WorkItem } from "../types/work";

export type ArchiveCategory = {
  id: string;
  label: string;
  caption: string;
  blurb: string;
  /** Empty for the product design tab, which renders Figma case studies instead. */
  items: WorkItem[];
};

/**
 * Archive films, supplied as Vimeo links. Titles and poster frames are read from
 * each film at runtime. Known masters are explicitly framed in their intended shape.
 */
const aspectOverrides: Partial<Record<string, WorkItem["aspect"]>> = {
  "1220450526": "square",
  "1220594505": "portrait",
};

function toItems(prefix: string, tags: string[], ids: string[]): WorkItem[] {
  return ids.map((vimeoId, index) => ({
    id: `${prefix}-${vimeoId}`,
    index: String(index + 1).padStart(3, "0"),
    vimeoId,
    tags,
    aspect: aspectOverrides[vimeoId],
    kind: aspectOverrides[vimeoId] ? "REEL" : undefined,
  }));
}

const motionIds = [
  "1214643167", "1214777791", "1215748705", "1220450526", "1220451191",
  "1220435552", "1213608264", "1215511396", "1178003422", "1214517898",
  "1214517044", "1216338100", "1177997028", "1220601235", "1214610680",
];

const editIds = [
  "1213219566", "1177991734", "1220562689", "1213857334", "1220563515",
  "1220563642", "1220594013", "1220594505", "1220625508", "1234597810",
  "1234598523", "1213870163", "1213859753",
];

export const archiveCategories: ArchiveCategory[] = [
  {
    id: "motion",
    label: "Motion Design & Animation",
    caption: "2D / 3D / Motion / CGI / VFX & Compositing",
    blurb: "Animation, CGI and compositing work across commercial, broadcast and social delivery.",
    items: toItems("motion", ["MOTION", "CGI", "VFX"], motionIds),
  },
  {
    id: "edit",
    label: "Video Editing & Post-Production",
    caption: "Edit / Post / Delivery",
    blurb: "Edits, finishing and platform delivery for films, campaigns and long-form content.",
    items: toItems("edit", ["EDIT", "POST", "DELIVERY"], editIds),
  },
  {
    id: "product",
    label: "UI UX / Product Design",
    caption: "Flows / Interfaces / Systems",
    blurb: "Interface and product design carrying the same craft as the film work. Each case opens its frames in Figma.",
    items: [],
  },
];
